import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import { useRecoilValue } from "recoil";
import authProfileState from "../../states/authProfileState";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import defineConf from "../../config/defineConf";

function TkPartnerPriceAgreementUpdateButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, priceAgreementSelect, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [formData, setFormData] = useState();

    const authProfile = useRecoilValue(authProfileState);

    const onOpen = () => {
        if (grid) {
            const modifiedSchema = cloneDeep(schema);
            const selectTarget = cloneDeep(grid.selectedItems[0]);

            if (modifiedSchema && selectTarget) {
                for (const column of modifiedSchema.columns) {
                    switch (column.name) {
                        case "ourPrice": // 본사 가격
                            if (authProfile.companyInfo?.typeOwn) {
                                column.disabled = false;
                            } else {
                                column.disabled = true;
                            }
                            break;

                        case "partnerPrice": // 협력사 가격
                            if (
                                selectTarget.agreementType ===
                                    defineConf.agreementType.ORDER_PURCHASE_PRICE_AGREEMENT ||
                                selectTarget.agreementType ===
                                    defineConf.agreementType.ELECTRODE_PURCHASE_PRICE_AGREEMENT
                            ) {
                                if (authProfile.companyInfo?.typeSupplyer) {
                                    column.disabled = false;
                                } else {
                                    column.disabled = true;
                                }
                            } else {
                                column.hideInForm = true;
                            }
                            break;

                        case "processTimeHour": // 공정 시간 (시)
                            if (selectTarget.agreementType === defineConf.agreementType.OUTSOURCING_PRICE_AGREEMENT) {
                                if (authProfile.companyInfo?.typeOutSourcing) {
                                    column.disabled = false;
                                } else {
                                    column.disabled = true;
                                }
                            } else {
                                column.hideInForm = true;
                            }
                            break;

                        case "processName": // 공정 명
                            if (
                                !(
                                    selectTarget.agreementType ===
                                        defineConf.agreementType.OUTSOURCING_PRICE_AGREEMENT &&
                                    authProfile.companyInfo?.typeOutSourcing
                                )
                            ) {
                                column.hideInForm = true;
                            }
                            break;

                        case "relatedDoc":
                            if (authProfile.companyInfo?.typeSupplyer || authProfile.companyInfo?.typeOutSourcing) {
                                column.hideInForm = true;
                            }
                            break;

                        case "description":
                            column.disabled = false;
                            break;

                        default:
                            column.disabled = true;
                            break;
                    }
                }

                setModifiedSchema(modifiedSchema);
            }

            if (authProfile.companyInfo?.typeOwn) {
                if (!selectTarget.ourPrice) {
                    // 2023/01/16 : 고홍기 대표 요구 사항
                    selectTarget.ourPrice = selectTarget.partnerPrice;
                }
            }

            setFormData({ ...selectTarget });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onUpdateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <>
            <UpdateRecordButtonLayout id={id + "-update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id + "-update-dialog"}
                mode="edit"
                formId={id + "-update-form"}
                title={schema ? t(`dialog.title.${schema.name}.update`) : ""}
                schema={modifiedSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                doNotUseKeyAsUrlWhenUpdate
                modifyUrlCallback={(url) => {
                    const selectTarget = grid.selectedItems[0];

                    if (selectTarget.agreementType === defineConf.agreementType.ORDER_PURCHASE_PRICE_AGREEMENT) {
                        return `${url}/${selectTarget.agreementType}/${selectTarget.orderPurchaseDetailId}/1`;
                    } else if (selectTarget.agreementType === defineConf.agreementType.OUTSOURCING_PRICE_AGREEMENT) {
                        return `${url}/${selectTarget.agreementType}/${selectTarget.outSourcingDetailId}/${selectTarget.processCode}`;
                    } else if (
                        selectTarget.agreementType === defineConf.agreementType.ELECTRODE_PURCHASE_PRICE_AGREEMENT
                    ) {
                        return `${url}/${selectTarget.agreementType}/${selectTarget.electrodeDetailId}/1`;
                    }

                    return url;
                }}
            />
        </>
    );
}

export default TkPartnerPriceAgreementUpdateButton;
